<script>
import appConfig from '@src/app.config'
import { applyUpdateNow, onNotify } from '@utils/sw-update'

export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title} | ${appConfig.title}` : appConfig.title
    },
  },
  data() {
    return {
      registration: null,
      snackbar: false,
      refreshing: false,
    }
  },
  created() {
    document.addEventListener('swUpdated', this.showRefreshUI, { once: true })
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (this.refreshing) return
      this.refreshing = true
      window.location.reload()
    })
  },
  beforeUnmount() {
    document.removeEventListener('swUpdated', this.showRefreshUI)
  },
  methods: {
    showRefreshUI(e) {
      this.registration = e.detail
      this.snackbar = true
    },
    refreshApp() {
      this.snackbar = false
      if (!this.registration || !this.registration.waiting) {
        return
      }
      this.registration.waiting.postMessage('skipWaiting')
    },
  },
}
</script>

<template>
  <div id="app">
    <!--
    Key on `path` (not `fullPath`) so navigating to a different route recreates
    the component, but a query-only change (e.g. ?locationId=…) updates props in
    place instead of tearing down and rebuilding the whole view. Views that read
    query params do so through reactive props / Apollo `variables()`, so they
    refetch without a remount. Keying on `fullPath` remounted on every query
    change, which caused the visible "jump" / flash on navigation.
    -->
    <router-view :key="$route.path" />
    <v-snackbar v-model="snackbar" color="accent" bottom right :timeout="-1">
      New Version Available
      <v-spacer />
      <v-btn variant="text" @click="refreshApp"> Refresh </v-btn>
      <v-btn icon @click="snackbar = false"><v-icon>$close</v-icon></v-btn>
    </v-snackbar>
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

@import 'normalize.css/normalize.css';

// A neutral OUTLINED button. Vuetify draws an outlined border from
// currentColor, which on an uncoloured button is on-surface at 0.87: a
// near-black hairline that outshouts a coloured button beside it. This drops
// only the BORDER to a grey and leaves the label at full emphasis. 0.45 is the
// lowest that still clears the 3:1 WCAG floor for a control's boundary in both
// themes (3.36:1 on the light surface, 4.39:1 on the dark one). A theme token,
// never a fixed grey, so it follows whatever surface it is drawn on.
//
// Global rather than scoped because the LOTO page and the procedures card both
// use it. `.v-btn` is in the selector to outrank Vuetify's own
// `.v-btn--variant-outlined` shorthand, which otherwise ties on specificity and
// wins or loses on injection order.
.v-btn.btn-neutral-outline {
  border-color: rgba(var(--v-theme-on-surface), 0.45);
}

// @import '~nprogress/nprogress.css';
// ===
// Vendor
// ===

// #nprogress .bar {
//   background: #ff4136;
// }
</style>
